import React, { useState, useEffect, useContext } from "react";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getActiveClientsAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const ClientCount = ({ selectedSucursal }) => {
  const [activeClients, setActiveClients] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getActiveClientsAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setActiveClients(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/clients`)}
      icon={<GroupRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="info.light"
      iconColor="info.main"
      value={activeClients}
      label="Clientes activos"
    />
  );
};

export default ClientCount;
